import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Siparis} from '../model/siparis';
import {Router} from '@angular/router';
import {SiparisComponent} from '../siparis/siparis.component';
import { AuthService } from 'src/auth/auth.service';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-siparis-liste',
  templateUrl: './siparis-liste.component.html',
  styleUrls: ['./siparis-liste.component.css']
})
export class SiparisListeComponent implements OnInit {

  DURUM_ONAY_BEKLIYOR = Siparis.DURUM_ONAY_BEKLIYOR;
  DURUM_ONAYLANDI = Siparis.DURUM_ONAYLANDI;
  DURUM_REDDEDILDI = Siparis.DURUM_REDDEDILDI;

  siparisler: Siparis[] = null;
  userGrupId: number;
  pIsSiparis: boolean = false;

  // @Output() onayGuncelle = new EventEmitter<any>();
  @Output() updateSiparisler = new EventEmitter<boolean>();


  @Input()
  public set source(siparisler: Siparis[]) {
    if (siparisler != null) {
      this.siparisler = siparisler;
    }
  }

  @Input()
  public set isSiparis(pIsSiparis: boolean) {
    this.pIsSiparis = pIsSiparis;
  }

  constructor(private router: Router
    , private authService: AuthService
    , private restService: RestService) {
  }

  ngOnInit(): void {
    this.userGrupId = this.authService.getUser().kullaniciGrupId;
  }

  incele(t: Siparis) {
    this.router.navigate(['siparis'], {queryParams: {id: t.id}});
  }

  // onayla(idParam, durumParam) {
  //   this.onayGuncelle.emit({id: idParam, durum: durumParam});
  // }

  irsaliyeGir(s: Siparis) {
    this.router.navigate(['siparis'], {queryParams: {siparisId: s.id, action: SiparisComponent.ACTION_IRSALIYE_OLUSTUR}});
  }

  iptalEt(id: number) {
    if (confirm(`Siparişi silmek istediğinize emin misiniz?`)) {
      this.restService.siparisIptal(id).subscribe(res => {
          this.updateSiparisler.emit(true);
      });
    }
  }
}
